import React from "react"
import { useTranslation } from "react-i18next"

interface WidgetPartnersProps {
    partners: { url: string, data: { imgSrc: string, imgAlt: string } }[];
}

export const WidgetPartners: React.FC<WidgetPartnersProps> = ({ partners }) => {
    const { t } = useTranslation();
    return (
        <div className="widget p-4">
            <div className="widget-title">
                <h2>{t('widgets.partners.title')}</h2>
            </div>
            <ul className="list-unstyled list-style mb-0">
                {partners.map(({ url, data: { imgSrc, imgAlt } }) => (
                    <li key={imgSrc} className="mb-3">
                        <a href={url} target="_blank" title={imgAlt}>
                            <img src={imgSrc} alt={imgAlt} className="w-100" />
                        </a>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default WidgetPartners;